import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import AddApps from 'features/apps/add-apps/components';

const AddAppsPage = () => {
  return (
    <>
      <Navbar showPreviousBtn />
      <Box css={{ height: 'calc( 100vh - 58px )' }}>
        <AddApps />
      </Box>
    </>
  );
};

export default AddAppsPage;
